import styled, { css } from "styled-components";
import * as Flex from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";

export const Wrapper = styled(Flex.Row)`
    position: relative;
    padding-top: 47.43%;
`;

export const Wrapper3dSpin = styled(Flex.Row)`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    padding-top: 47.43%;
`;

export const SpinPlayer = styled.div<{ isFullscreen?: boolean }>`
    position: absolute;
    top: ${theme.space[3]}px;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    padding-top: 40.27%; /* = (446 /1160) * 100 */
    z-index: 1; /* This is necessary else the car image is shown above the navigation menu OR-4252 */

    @media ${getBreakpoint("up", "xl")} {
        top: 0;
    }

    ${({ isFullscreen }) =>
        isFullscreen &&
        css`
            left: 50%;
            max-width: 374px;
            transform: translateX(-50%);

            @media ${getBreakpoint("up", "md")} {
                max-width: 768px;
            }

            @media ${getBreakpoint("up", "xl")} {
                max-width: 1600px;
            }
        `};
`;

export const SpinImage = styled.img<{ opacity: number; transition?: string; zindex?: number }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 374px;
    height: auto;
    max-height: none;
    pointer-events: none;
    user-select: none;
    opacity: ${(props) => props.opacity};

    @media ${getBreakpoint("up", "sm")} {
        max-width: 768px;
        max-height: none;
    }

    @media ${getBreakpoint("up", "xl")} {
        max-width: 1600px;
    }

    ${({ transition }) =>
        transition &&
        css`
            transition: ${transition};
        `};
    ${({ zindex }) =>
        zindex &&
        css`
            z-index: ${zindex};
        `};
`;

export const SnowCanvas = styled.canvas`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 3;
`;

export const Spin3dCanvas = styled.canvas<{ hidden: boolean }>`
    display: ${({ hidden }) => (hidden ? "none" : "block")};
    position: absolute;
    top: 75px;
    left: 20%;
    width: 60%;
    height: 100%;
    user-select: auto;

    @media ${getBreakpoint("down", "md")} {
        top: 10px;
        left: 0;
        width: 100%;
        height: 100%;
    }

    @media ${getBreakpoint("up", "md")} {
        top: 0;
    }
`;

export const ResetButton = styled.a`
    display: flex;
    position: absolute;
    bottom: 0;
    left: 50%;
    align-items: center;
    padding: 13px 20px;
    font-family: ${theme.fonts.base};
    font-size: 1.6rem;
    color: ${theme.colors.primaryBlack};
    background-color: ${theme.colors.grey1};
    border-radius: 30px;
    transform: translateX(-50%);
    user-select: none;
    z-index: ${theme.zIndex.overlay};

    @media ${getBreakpoint("up", "lg")} {
        bottom: 10%;
        background-color: transparent;
    }

    svg {
        margin-top: 3px;
        margin-left: ${theme.space[1]}px;
    }

    html[dir="rtl"] & {
        svg {
            margin-left: 0;
            margin-right: ${theme.space[1]}px;
        }
    }
`;
